import { createClient } from "./http";
import { env } from "../config/env";

const client = createClient(env.SUPPORT_BASE_URL);

export const SupportService = {
  getStats: () => client.get("/api/support/admin/stats"),
  getSettings: () => client.get("/api/support/admin/settings"),
  updateSettings: (body) => client.patch("/api/support/admin/settings", body),
  listConversations: (params = {}) => client.get("/api/support/admin/conversations", { params }),
  getConversation: (id) => client.get(`/api/support/admin/conversations/${id}`),
  getMessages: (id, params = {}) => client.get(`/api/support/admin/conversations/${id}/messages`, { params }),
  sendMessage: (id, { message = "", files = [] } = {}) => {
    const form = new FormData();
    if (message) form.append("message", message);
    (files || []).forEach((file) => form.append("files", file));
    return client.post(`/api/support/admin/conversations/${id}/messages`, form);
  },
  markRead: (id) => client.post(`/api/support/admin/conversations/${id}/read`, {}),
  updateStatus: (id, status) => client.patch(`/api/support/admin/conversations/${id}/status`, { status }),
  assignToMe: (id) => client.post(`/api/support/admin/conversations/${id}/assign-me`, {}),
  clearConversation: (id) => client.post(`/api/support/admin/conversations/${id}/clear`, {}),
  clearAll: (confirmation) => client.post("/api/support/admin/conversations/clear-all", { confirmation }),
};
